export default "__VITE_PUBLIC_ASSET__f51c07f5__"